<template>
    <div class="guest-code-form">
        <p>{{ $t('pages.public.shared_records.guest_code_hint') }}</p>
        <input
            v-model.trim="accessCode"
            type="text"
            inputmode="numeric"
            maxlength="6"
            class="code-input"
            :placeholder="$t('pages.public.shared_records.guest_code_placeholder')"
            @keydown.enter.prevent="submit"
        />
        <p v-if="errorMessage" class="error">{{ errorMessage }}</p>
        <common-buttons align="center">
            <common-button
                :label="$t('pages.public.shared_records.verify_code')"
                type="primary"
                :isProcessing="isSubmitting"
                :isDisabled="!isCodeValid || isSubmitting"
                @click="submit"
            ></common-button>
            <common-button
                :label="$t('pages.public.shared_records.back')"
                type="secondary"
                @click="$emit('back')"
            ></common-button>
        </common-buttons>
    </div>
</template>

<script>
    import DocumentSharesAPI from 'api/DocumentSharesAPI'

    export default {
        props: {
            token: { type: String, required: true },
        },

        data() {
            return {
                accessCode: '',
                isSubmitting: false,
                errorMessage: '',
            }
        },

        computed: {
            isCodeValid() {
                return /^\d{6}$/.test(this.accessCode)
            },
        },

        methods: {
            guestStorageKey() {
                return `share-guest:${this.token}`
            },

            submit() {
                if (!this.isCodeValid || this.isSubmitting) return

                this.isSubmitting = true
                this.errorMessage = ''

                return DocumentSharesAPI.verifyCode(this.token, this.accessCode)
                    .then((res) => {
                        sessionStorage.setItem(this.guestStorageKey(), res.guestToken)
                        this.$emit('verified', res.guestToken)
                    })
                    .catch((err) => {
                        const res = err?.response || {}
                        const subCode = res.data?.subCode
                        const fieldErrors = Array.isArray(res.data) ? res.data : []
                        if (subCode === 'access_code.locked') {
                            this.errorMessage = this.$t('pages.public.shared_records.errors.code_locked')
                        } else if (fieldErrors.some((f) => f.code === 'access_code.invalid')) {
                            this.errorMessage = this.$t('pages.public.shared_records.errors.code_invalid')
                        } else {
                            this.errorMessage = this.$t('pages.public.shared_records.errors.code_failed')
                        }
                    })
                    .finally(() => {
                        this.isSubmitting = false
                    })
            },
        },
    }
</script>

<style scoped lang="scss">
    .guest-code-form {
        max-width: 360px;
        margin: 0 auto;
    }

    .code-input {
        width: 100%;
        padding: 10px 12px;
        border: 1px solid #d1d5db;
        border-radius: 6px;
        font-size: 18px;
        letter-spacing: 4px;
        text-align: center;
        margin-bottom: 12px;
        box-sizing: border-box;

        &:focus {
            outline: none;
            border-color: #2e8b57;
        }
    }

    .error {
        color: #c62828;
        margin-bottom: 12px;
        font-size: 13px;
    }
</style>
